// USED IN FLEXIBLE COLUMN CONTAINER BLOCK, EXTENDED SEARCH BLOCK

import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

import "swiper/css";

export default function SwiperHeroCarousel() {
  const swiperElement = document.querySelectorAll<HTMLDivElement>(".js-swiper-hero-carousel");

  if (swiperElement && swiperElement.length > 0) {
    Swiper.use([Navigation, Autoplay, Pagination]);

    swiperElement.forEach((el: HTMLDivElement) => {
      if (el) {
        const carouselEl = el.querySelector<HTMLDivElement>(".swiper");
        const nextBtn = el.querySelector<HTMLButtonElement>(".swiper-btn-next");
        const prevBtn = el.querySelector<HTMLButtonElement>(".swiper-btn-prev");
        
        if (carouselEl) {
          const setAutoplay = carouselEl.getAttribute("data-swiper-autoplay");
          const speed = carouselEl.getAttribute("data-speed");
          const paginationEl = el.querySelector<HTMLButtonElement>(".swiper-pagination");

          new Swiper(carouselEl, {
            loop: false,
            navigation: {
              nextEl: nextBtn,
              prevEl: prevBtn,
            },
            slidesPerView: 1,
            spaceBetween: 24,
            autoplay: setAutoplay != "False"  ? { 
                delay: speed ? parseInt(speed) : 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              } : false,
            pagination: {
                el: paginationEl,
                clickable: true,
                type: "bullets",
                renderBullet: function (index, className) {
                    // Add descriptive text for each pagination bullet
                    return `<span class="${className} h-[6px] w-[6px] rounded-[99px] mx-[3px] inline-block cursor-pointer" role="button" aria-label="Go to slide ${index + 1}"></span>`;
                },
            },
          });

          function setVideoAutoplay() {
            const slides = carouselEl?.querySelectorAll<HTMLDivElement>(".swiper-slide");
            
            if(slides && slides.length > 0) {
              slides.forEach((slide) => {
                const slideVideo = slide.querySelector<HTMLVideoElement>(".js-video")

                if(slideVideo) {
                  if(slide.getAttribute('data-video-autoplay') === 'True' && slide.classList.contains('swiper-slide-active')) {
                    slideVideo.play();
                  } else {
                    slideVideo?.pause()
                  }
                }

              })
            }
          }
          
          //initial load
          setVideoAutoplay();

          nextBtn?.addEventListener("click",setVideoAutoplay);
          prevBtn?.addEventListener("click",setVideoAutoplay);
        }
      }
    });
  }
}
